const WORD_PATTERN = /[\p{L}\p{N}][\p{L}\p{N}\p{M}]*/gu;

function tokenizeWords(value: string): string[] {
  return value.toLowerCase().match(WORD_PATTERN) ?? [];
}

function matchesQueryWords(
  text: string,
  queryWords: readonly string[],
): boolean {
  if (queryWords.length === 0) return true;

  const textWords = tokenizeWords(text);
  let textWordIndex = 0;

  for (const queryWord of queryWords) {
    let found = false;
    while (textWordIndex < textWords.length) {
      const textWord = textWords[textWordIndex];
      textWordIndex += 1;
      if (textWord?.startsWith(queryWord)) {
        found = true;
        break;
      }
    }
    if (!found) return false;
  }

  return true;
}

export function hasWordPrefixQuery(query: string): boolean {
  return tokenizeWords(query).length > 0;
}

export function matchesWordPrefixes(text: string, query: string): boolean {
  return matchesQueryWords(text, tokenizeWords(query));
}

export function filterByWordPrefixes<T>(
  items: readonly T[],
  query: string,
  getText: (item: T) => string,
): readonly T[] {
  const queryWords = tokenizeWords(query);
  if (queryWords.length === 0) return items;
  return items.filter((item) => matchesQueryWords(getText(item), queryWords));
}
